import { render, staticRenderFns } from "./ResalesForm.vue?vue&type=template&id=e0fce3d4&"
import script from "./ResalesForm.vue?vue&type=script&lang=js&"
export * from "./ResalesForm.vue?vue&type=script&lang=js&"
import style0 from "./ResalesForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports